// Web app colour scheme: 'light' (default) or 'dark' (styles in ./dark.css,
// all under <html data-theme="dark">).
//
// The mobile app's web view sets window.fcTheme (and the attribute) before the
// page loads, so pages it opens follow the app's dark mode. A link can also ask
// with ?theme=dark / ?theme=light. Either is remembered for later pages in
// the same browser (the app's web view keeps its own storage).
import './dark.css';

const KEY = 'colorScheme';

const read = () => {
  try { return window.localStorage.getItem(KEY); } catch (e) { return null; }
};
const save = (s) => {
  try { window.localStorage.setItem(KEY, s); } catch (e) { /* storage off */ }
};

export const getColorScheme = () => (document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light');

export const setColorScheme = (scheme) => {
  const s = scheme === 'dark' ? 'dark' : 'light';
  document.documentElement.setAttribute('data-theme', s);
  save(s);
};

export const initColorScheme = () => {
  let asked = null;
  try { asked = new URLSearchParams(window.location.search).get('theme'); } catch (e) { asked = null; }
  asked = asked || window.fcTheme;
  if (asked === 'dark' || asked === 'light') {
    setColorScheme(asked);
  } else {
    document.documentElement.setAttribute('data-theme', read() === 'dark' ? 'dark' : 'light');
  }
};
